import { useLayoutEffect } from 'react';
import { useHistory } from 'react-router-dom';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { mountPoint } from 'utils/generic/route-manipulation';

export const useCasinoRedirect = (
  shouldFetch = false,
  noCasinoMonthPath = false
): void => {
  const location = window.location;
  const history = useHistory();

  useLayoutEffect(() => {
    if (SpringConfigs.MOCKED_DATA || !shouldFetch) {
      return;
    }

    const [shouldRedirect, redirectPath] = mountPoint(
      location.pathname,
      true,
      true,
      noCasinoMonthPath
    );

    shouldRedirect && history.push(redirectPath);
  }, []);
};
